import { Box } from '@chakra-ui/react';

import { TextMedium, TextRegular } from 'UiKit/typography';
import Tooltip from 'UiKit/tooltip';

import ColumnWarehouse from 'View/stock-promo/component/columnWarehouse';
import ColumnStock from 'View/stock-promo/component/columnStock';
import ColumnBarcode from 'View/stock-promo/component/columnBarcode';
import ColumnImage from 'View/stock-promo/component/columnImage';

import styles from '../styles.module.css';

const tableStockList = ({ t }) => {
  return [
    {
      name: t('columnTableStockProduct.image'),
      key: 'imagePath',
      width: 120,
      position: 'center',
      component: ({ value }) => <ColumnImage image={value} />,
    },
    {
      name: t('columnTableStockProduct.barcode'),
      key: 'sku',
      width: 170,
      position: 'left',
      component: ({ value }) => <ColumnBarcode value={value} />,
    },
    {
      name: t('columnTableStockProduct.productNameAndBrand'),
      key: 'name',
      width: 250,
      position: 'left',
      component: ({ value, values }) => {
        return (
          <Box className={styles['table-stock__cell--product']}>
            <Tooltip label={value}>
              <TextMedium className={styles['table-stock__text--name']}>{value}</TextMedium>
            </Tooltip>
            <TextRegular className={styles['table-stock__text--brand']}>{values?.brand}</TextRegular>
          </Box>
        );
      },
    },
    {
      name: t('columnTableStockProduct.totalStock'),
      key: 'totalAvailableStock',
      width: 140,
      position: 'left',
      component: ({ value }) => {
        return (
          <Box className={styles['table-stock__cell--product']}>
            <TextRegular className={styles['table-stock__text--brand']}>{value}</TextRegular>
          </Box>
        );
      },
    },
    {
      name: t('columnTableStockProduct.warehouse'),
      key: 'productStorages',
      width: 200,
      position: 'left',
      component: ({ value, values }) => <ColumnWarehouse value={value} values={values} />,
    },
    {
      name: t('columnTableStockProduct.stockWarehouse'),
      key: 'productStorages',
      width: 200,
      position: 'left',
      labelInfo: 'Jumlah stok yang masih tersedia dan siap digunakan',
      component: ({ value }) => {
        return <ColumnStock value={value} />;
      },
    },
  ];
};

export default tableStockList;
